import { type StyleProp } from 'react-native';
import { type Style } from 'twrnc';

import { Label } from '~/common/styleguide';
import tw from '~/util/tailwind';

type Props = {
  count: number;
  style?: StyleProp<Style>;
};

export default function EntityCounter({ count, style }: Props) {
  return (
    <Label
      style={[
        tw`mt-[3px] h-4.5 text-[11px] rounded-xl py-0.5 px-1.5 text-[inherit] bg-palette-gray2 dark:bg-accented`,
        style,
      ]}>
      {count}
    </Label>
  );
}
